import type { RootState } from 'features/app/store/store';
import { AstSignMailHandoffStatus } from 'features/ast-signmail/interfaces';

export const selectAstSignMailHandoffStatus = ({ astSignMail }: RootState) =>
  astSignMail.handoffStatus;

export const selectIsAstSignMailHandoffActive = (state: RootState) =>
  selectAstSignMailHandoffStatus(state) === AstSignMailHandoffStatus.SHOWING;

/** True while AST owns SignMail destination (ownership transfer or handoff UI). */
export const selectIsAstSignMailDestinationClaimed = (state: RootState) => {
  const handoffStatus = selectAstSignMailHandoffStatus(state);
  return (
    handoffStatus === AstSignMailHandoffStatus.TRANSFERRING ||
    handoffStatus === AstSignMailHandoffStatus.SHOWING
  );
};

export const selectAstSignMailMode = ({ astSignMail }: RootState) =>
  astSignMail.astSignMailMode;

export const selectTransferAstRelayResponse = ({ astSignMail }: RootState) =>
  astSignMail.transferAstRelayResponse;
